// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_BuscaDeviceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/devices_franquias/buscaDevice/<id>
 *
 * Returns a single config_devices_franquias row enriched with the franquia_ids
 * relationship from devices_franquias_franquias. The dados shape mirrors the
 * columns of `config_devices_franquias` (see model `Devices_franquias_model`
 * `@phpstan-type DeviceFranquiaRow`) plus the `franquia_ids` enrichment the
 * controller performs after `busca_por_id()`.
 *
 * The fields below are flattened onto the response so the contract generator
 * emits a concrete runtime schema for `dados` (the prior `DeviceRow $device`
 * + `getDados()` override produced an empty `{}` runtime schema).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface DevicesFranquias_BuscaDeviceResponseDados {
device_id: number
numero_whatsapp: string
device_token: string
active: number
provider_type: string
franquia_ids: number[]
device_name?: string
api_url?: string
provider_config?: string
provider_account_id?: string
provider_username?: string
page_id?: string
page_access_token?: string
token_expires_at?: string
}

export type DevicesFranquias_BuscaDeviceResponse = ApiResponse<DevicesFranquias_BuscaDeviceResponseDados>;

registerResponseContract('DevicesFranquias_BuscaDeviceResponse', {
  device_id:           { type: 'number',  required: true },
  numero_whatsapp:     { type: 'string',  required: true },
  device_token:        { type: 'string',  required: true },
  active:              { type: 'number',  required: true },
  provider_type:       { type: 'string',  required: true },
  franquia_ids:        { type: 'array',   required: true },
  device_name:         { type: 'string',  required: false },
  api_url:             { type: 'string',  required: false },
  provider_config:     { type: 'string',  required: false },
  provider_account_id: { type: 'string',  required: false },
  provider_username:   { type: 'string',  required: false },
  page_id:             { type: 'string',  required: false },
  page_access_token:   { type: 'string',  required: false },
  token_expires_at:    { type: 'string',  required: false },
})
